import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=263ad368&scoped=true"
import script from "./MaterialDetail.vue?vue&type=script&lang=js"
export * from "./MaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialDetail.vue?vue&type=style&index=0&id=263ad368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ad368",
  null
  
)

export default component.exports